module.exports = __webpack_public_path__ + "img/ProjectJourney.395f08e8.jpg";